
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/m/offer/[slug]",
      function () {
        return require("private-next-pages/[locale]/m/offer/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/m/offer/[slug]"])
      });
    }
  